import { Pipe, PipeTransform } from "@angular/core";
import { CharDataType } from "../rl-common.consts";
import { CharDataTypeUtil } from "../utils/char-data-type.util";

@Pipe({ name: "charDataTypeName" })
export class CharDataTypeNamePipe implements PipeTransform {

	transform(value: CharDataType, ..._args: unknown[]): unknown {
		return CharDataTypeUtil.toDisplayName(value);
	}

}
